import { TransactionStatusEnum } from '../../../../tenant/transactions/enums/transaction-status.enum';
import { TransactionTypeEnum } from '../../../../tenant/transactions/enums/transaction-type.enum';
import { PrintableDepositResult } from '../interfaces/printable-deposit-result.interface';
import { ResolvePrintableDepositParams } from '../interfaces/resolve-printable-deposit-params.interface';
import { computeVehicleCategoryDeposit } from './compute-vehicle-category-deposit.function';

/**
 * Computes the vehicle-category deposit for a printable record and whether it is
 * still due at pickup (a positive deposit with no completed online deposit payment).
 */
export function resolvePrintableDeposit(
  params: ResolvePrintableDepositParams,
): PrintableDepositResult {
  const depositAmount = computeVehicleCategoryDeposit({
    depositFlatRate: params.depositFlatRate,
    depositPercentage: params.depositPercentage,
    discountedStandardGross: params.discountedStandardGross,
    percentageDepositRounding: params.percentageDepositRounding,
  });

  const depositPaidOnline = (params.transactions ?? [])
    .filter(
      (transaction) =>
        transaction.type === TransactionTypeEnum.DEPOSIT &&
        transaction.status === TransactionStatusEnum.COMPLETED,
    )
    .reduce((total, transaction) => total + Number(transaction.amount ?? 0), 0);

  return {
    depositAmount,
    isDepositDueAtPickup: depositAmount > 0 && depositPaidOnline <= 0,
  };
}
